import { z } from 'zod';

const HOST_RE = /^(?=.{1,253}$)(?!-)[a-z0-9-]{1,63}(?<!-)(\.(?!-)[a-z0-9-]{1,63}(?<!-))+\.?$/i;

export const migrationSourceSchema = z.object({
  sourceHost: z.string().trim().min(1, 'Server is required').regex(HOST_RE, 'Enter a hostname such as imap.example.com'),
  sourcePort: z.coerce.number().int('Whole number').min(1, '1–65535').max(65535, '1–65535'),
  sourceSecurity: z.enum(['ssl', 'starttls']),
  sourceUsername: z.string().trim().min(1, 'Username is required').max(320),
  sourcePassword: z.string().min(1, 'Password is required').max(1024),
});

export const createMigrationSchema = migrationSourceSchema.extend({
  destinationMailboxId: z.string().uuid('Choose the Nifty mailbox to import into'),
});
export type CreateMigrationValues = z.infer<typeof createMigrationSchema>;

export const rerunMigrationSchema = z.object({
  sourcePassword: z.string().min(1, 'Password is required').max(1024),
});
export type RerunMigrationValues = z.infer<typeof rerunMigrationSchema>;
